import { useEffect, useRef } from 'react';
import { useTheme, resolveTheme } from '../../contexts/ThemeContext';
import { useUserSettings } from '../admin/settings/useData';

/**
 * Applies the authenticated user's saved theme once per user session
 * (server preference wins over localStorage when present).
 */
export function UserThemeSync() {
  const { setTheme } = useTheme();
  const { userSettings, isLoading } = useUserSettings();
  const syncedForUser = useRef<number | null>(null);

  useEffect(() => {
    if (isLoading || !userSettings) return;
    if (syncedForUser.current === userSettings.userId) return;
    syncedForUser.current = userSettings.userId;

    if (!userSettings.theme) return;
    setTheme(resolveTheme(userSettings.theme));
  }, [userSettings, isLoading, setTheme]);

  return null;
}

export default UserThemeSync;
